
import React, { useEffect, useState, Children, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import CloudformationOutputs from '../CloudformationOutputs.json'
import { Link } from "react-router-dom"
import Button from '../formfields/Button'
import FolderStructure from './FolderStructure'
import ButtonMenu from '../ui-elements/ButtonMenu'
import { alphabetiseFolders } from '../utils/alphabetiseFolders'
import DeleteButton from '../formfields/DeleteButton'
import { subscribe } from '../utils/pubsub'
import JsonDebug from '../ui-elements/JsonDebug'

type Props = {
    folders: ObjectStringKeyAnyValue
    type?: string
    setItemToMove: React.Dispatch<React.SetStateAction<any>>
    showIndentation?: boolean
}


function DisplayRecursiveFolder({
    folders,
    type,
    setItemToMove,
    showIndentation = true
}: Props) {


    const alphabetisedArray = alphabetiseFolders(folders)
    const { tableData, sendMessageToWebsocket, setShowModal, currentPortalId } = useContext(GlobalContext)

    const deleteFolder = (itemId: string) => {
        setShowModal({ "spinner": 'Deleting...' })
        const payload: ObjectStringKeyAnyValue = {
            action: "portal",
            subAction: "deleteFolder",
            folderId: itemId
        }

        const unsubscribe = subscribe("folderDeleted", data => {
            if (data.Id === itemId) {
                setShowModal(null)
            }
            unsubscribe()
        })
        sendMessageToWebsocket(JSON.stringify(payload))
    }

    const thisPortal = tableData.Portals ? tableData.Portals[currentPortalId] : null
    const repositoryOrganisationIdsForThisPortal = thisPortal && thisPortal.repositoryOrganisationIds || []

    const dashboardBaseUrl = CloudformationOutputs.StackName === `checqrtesting` ? 'https://test-dashboard.checqr.net/' : 'https://dashboard.checqr.net/'

    return <div className={`w-full flex flex-col gap-1`}>

        {alphabetisedArray.map((thisItemId: string, index: number) => {
            const thisItem = folders[thisItemId]

            const showDeleteButton = thisItem && type !== 'organisation' && (!thisItem.Organisations || Object.keys(thisItem.Organisations).length === 0) && (!thisItem.Subfolders || Object.keys(thisItem.Subfolders).length === 0)

            if (!thisItem) return null
            return <div key={index} className={`w-full flex flex-col gap-1 ${showIndentation && ` pl-5 `}`}>




                {type !== 'organisation' && <div className={`text-sm h-10 relative rounded px-3 py-2 border border-1 flex flex-row items-center justify-between bg-yellow-100 border-yellow-400`}>

                    <div className={`flex flex-row items-center gap-2`}>
                        <img src={`/icons/Icons8_flat_folder.svg`} className={`h-4 w-4`} />
                        <p className={``}>{thisItem.DisplayName || thisItemId}</p>
                    </div>
                    <div className={`flex flex-row items-center gap-1`}>
                        {showDeleteButton &&
                            <DeleteButton
                                deleteFunction={deleteFolder}
                                functionParams={thisItemId}
                                size={'small'}
                            />}

                        <Button
                            onClick={() => setItemToMove({ thisItemId, type, 'ParentFolderId': thisItem.ParentFolderId })}
                            text='Move'
                            fullwidth={false}
                            variant='secondary'
                            size={'small'}
                        />
                    </div>

                </div>}


                {type === 'organisation' && <div className={`text-sm h-10 relative rounded px-3 py-2 border border-1 flex flex-row items-center justify-between border-brandblue bg-brandblue text-white`}>

                    <div className={`flex flex-row items-center gap-2`}>

                        {repositoryOrganisationIdsForThisPortal.includes(thisItemId) && <p>⭐️</p>}
                        <p className={``}>{thisItem.DisplayName || thisItemId}</p>
                    </div>


                    <div className={`flex flex-row items-center gap-1`}>
                        <Button
                            externalLinkUrl={`${dashboardBaseUrl}?selectOrg=${thisItemId}`}
                            text='Log in'
                            fullwidth={false}
                            variant='secondary'
                            size={'small'}
                        />

                        <Button
                            onClick={() => setItemToMove({ thisItemId, type, 'ParentFolderId': thisItem.ParentFolderId })}
                            text='Move'
                            fullwidth={false}
                            variant='secondary'
                            size={'small'}
                        />
                    </div>

                </div>}

                {
                    thisItem.Organisations && Object.keys(thisItem.Organisations).length > 0 && <DisplayRecursiveFolder
                        showIndentation={true}
                        setItemToMove={setItemToMove}
                        type={`organisation`} folders={thisItem.Organisations}
                    />
                }
                {
                    thisItem.Subfolders && Object.keys(thisItem.Subfolders).length > 0 && <DisplayRecursiveFolder
                        showIndentation={true}
                        setItemToMove={setItemToMove}
                        type={`folder`}
                        folders={thisItem.Subfolders}
                    />
                }
            </div>
        })}
    </div >
}

export default DisplayRecursiveFolder